module.exports = __webpack_public_path__ + "static/img/CAMERON-NAIRN.9a05e20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CAMERON-NAIRN.jpg
// module id = +cvK
// module chunks = 0